import React, {useEffect, useState} from 'react';
import Modal from '../../../Presentation/components/ui/Modal';
import AddProductForm from './AddProductForm';
import {useProducts} from '../hooks/useProducts';
import {useNotification} from '../../../Services/useNotification';
import StandardizedErrorHandler from '../../../Services/common/StandardizedErrorHandler';
import {ProductAPIDataSource} from '../api';

interface EditProductModalProps {
  isOpen: boolean;
  productId: number | null;
  onClose: () => void;
  onSuccess?: () => void;
}

const EditProductModal: React.FC<EditProductModalProps> = ({isOpen, productId, onClose, onSuccess}) => {
  const {updateProduct} = useProducts();
  const {success: showSuccess} = useNotification();
  const [submitting, setSubmitting] = useState(false);
  const [initial, setInitial] = useState<any>(null);

  useEffect(() => {
    const load = async () => {
      if (!isOpen || !productId) {return;}
      try {
        const dto = await ProductAPIDataSource.getById(productId);
        setInitial({
          name: dto.name,
          typeId: (dto as any).type?.id ?? undefined,
          brandId: dto.brand?.id ?? undefined,
          price: typeof dto.price === 'string' ? Number(dto.price) : dto.price,
          barcode: dto.barcode ?? '',
          hasSerial: dto.has_serial,
          tags: Array.isArray(dto.tags) ? dto.tags.map(t => t.id) : []
        });
      } catch (e) {
        StandardizedErrorHandler.getInstance().handleError(e);
      }
    };
    load();
  }, [isOpen, productId]);

  const handleSubmit = async (formData: FormData) => {
    if (!productId) {return;}
    setSubmitting(true);
    try {
      await updateProduct(productId, formData);
      showSuccess('تم تحديث المنتج بنجاح');
      onSuccess?.();
      onClose();
    } catch (error: any) {
      StandardizedErrorHandler.getInstance().handleError(error);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      title="تعديل المنتج"
      width="max-w-4xl"
    >
      <div className="space-y-6">
        <AddProductForm
          onSubmit={handleSubmit}
          onCancel={onClose}
          submitting={submitting}
          initial={initial || undefined}
          submitLabel="تحديث"
          allowStockChanges={false}
          canEditHasSerial={false}
        />
      </div>
    </Modal>
  );
};

export default EditProductModal;


